module.exports = __webpack_public_path__ + "img/behance-square.9c87bd37.svg";